import { getDynamicSetting } from 'utils/dynamicSettings';

const serverUrl = getDynamicSetting('server_url');

const PLATFORM_ENDPOINT = 'platform/v2';

export const BASE_URL = `${serverUrl}/${PLATFORM_ENDPOINT}`;

export const ERROR_TRACK_EVENTS = {
  GET_USER: 'get user error',
  GET_INDEXING_STATISTICS: 'get indexing statistics error',
  GET_INDEXING_CONFIGURATION: 'get indexing configuration error',
  DISCONNECT_GIT_PROVIDER: 'disconnect git provider error',
  INVITE_MEMBERS: 'invite members error',
  CREATE_CUSTOMER_PORTAL_SESSION: 'create customer portal session error',
  CREATE_CHECKOUT_SESSION: 'create checkout session error',
  UPDATE_USER: 'update user error',
};
export const INVALID_ENTRIES_IN_FILE = 'INVALID_ENTRIES_IN_FILE';
